import PropTypes from 'prop-types';

import rangeType from './range';
import regexType from './regex';

PropTypes.range = rangeType;
PropTypes.regex = regexType;

export default PropTypes;
